import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat } from 'apollo-link';
import { get } from 'lodash';

const httpLink = new HttpLink({ 
  uri: `${process.env.REACT_APP_API_URL}/graphql` 
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const reduxState = localStorage.getItem('reduxState');
  if (reduxState){
    let fullState;
    fullState = JSON.parse(reduxState);

    let token = get(fullState, 'auth.customerToken', "");
    if(token === "")
      token = get(fullState, 'auth.guestToken', "");

    // add the authorization to the headers
    operation.setContext({
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  return forward(operation);
});

const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
});

export default client;


// WEBPACK FOOTER //
// ./src/graphql/ApolloClient.js